module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAACMCAYAAABbEgjLAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAABKADAAQAAAABAAAAjAAAAABE+gVRAAAAOElEQVRIDWP8DwQMSIAJiQ1mjgqghshoeIyGB1IIjCYHpMAAMkfDYzQ8kEJgNDkgBcZo9hjWyQEAIiwFFMEw09UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-fg.png
// module id = QzL0
// module chunks = 0